<!--

	The play button on the children landing page 
	that displays the cover video in the lightbox.

-->
<template>
	<div>
		<div class="mia-VideoPlayButton" :class="[excludedFromClickOutsideClass]" @click.stop="open">
			<div class="mia-playImageContainer">
				<div class="mia-playImage">
					<img src="@theme/parents/landingpage/play-triangle.svg" class="mia-playTriangle" :alt="$tr('StartVideoPlaybackAlt')">
					<img src="@theme/parents/landingpage/play-circle.svg" class="mia-playCircle" :alt="$tr('StartVideoPlaybackAlt')">
				</div>
			</div>
		</div>
		<lightbox v-show="isVideoOpen" @close="close">
			<vimeo-player ref="vimeoPlayer" :video-src="videoUrl" :enable-google-tracking="true" />
		</lightbox>
	</div>
</template>
<script lang="ts">
import { Component, Vue, Prop, toNative } from "vue-facing-decorator";
import Lightbox from "@/Control/Vue/Lesson/Lightbox.vue";
import VimeoPlayer, { type VimeoPlayer as VimeoPlayerType } from "@/Control/Vue/VimeoPlayer.vue";
import ClickOutsideHelper from "@/utils/ClickOutsideHelper";

@Component({
	components: {
		Lightbox,
		VimeoPlayer
	}
})
export class CoverVideoPlayButton extends Vue {
	@Prop({ required: true, type: String }) videoUrl!: string;

	vimeoPlayer!: VimeoPlayerType;
	isVideoOpen = false;
	excludedFromClickOutsideClass = ClickOutsideHelper.EXCLUDED_FROM_CLICK_OUTSIDE_CLASS;

	mounted() : void {
		this.vimeoPlayer = this.$refs.vimeoPlayer as VimeoPlayerType;
	}

	close() : void {
		this.isVideoOpen = false;
		void this.vimeoPlayer.pause();
	}

	open() : void {
		this.isVideoOpen = true;
		void this.vimeoPlayer.play();
	}
}

export default toNative(CoverVideoPlayButton);
</script>
<style lang="scss">
.mia-CoverVideoPlayButton > .mia-VideoPlayButton {
	> .mia-playImageContainer {
		position: absolute;
		width: 100%;
		bottom: 0;
		// This margin-bottom is responsible for the vertical space between the play button and the element beneath it.
		margin-bottom: theme.$mia-margin-size-large;

		> .mia-playImage {
			position: relative;
			margin: 0 auto;
			width: fit-content;
			
			> .mia-playCircle {
				position: absolute;
				left: 0;
				transition: transform .2s;
			}
		}
	}

	&:hover > .mia-playImageContainer > .mia-playImage > .mia-playCircle {
		transform: scale(1.2);
	}
}
</style>
